let host = 'emqtt-test.yunext.com'
let port = 8193
let useSSL = true // true为使用wss
if (window.location.host === 'xiao-weixin-test.yunext.com') {
  // 测试服
  host = 'emqtt-test.yunext.com'
  if (window.location.protocol === 'https:') {
    port = 8193
    useSSL = true
  }
  if (window.location.protocol === 'http:') {
    port = 8183
    useSSL = false
  }
}
if (window.location.host === 'elife.xiolift.com') {
  // 正式服
  host = 'elife.xiolift.com'
  if (window.location.protocol === 'https:') {
    port = 8084
    useSSL = true
  }
  if (window.location.protocol === 'http:') {
    port = 8083
    useSSL = false
  }
}
// 从 1970-01-01 00:00:00 到目前所经过的秒数 用于是二维码防伪   PS:后端接口提供
let getSecondForQrcode = (res) => {
  let timeOld = Number((res / 1000).toFixed(0)).toString(16).toLocaleUpperCase().split('')
  let arr = [timeOld[0] + timeOld[1], timeOld[2] + timeOld[3], timeOld[4] + timeOld[5], timeOld[6] + timeOld[7]]
  return arr
}

export default {
  host,
  port,
  useSSL,
  getSecondForQrcode
}



// WEBPACK FOOTER //
// ./src/utils/mqtt.js